import React from 'react';
import moment from "moment";
import _ from "lodash";
import {connect} from "react-redux";

import { Grid } from '@material-ui/core';

import NonFieldErrors from '../../../../../components/AssetModal/components/NonFieldErrors';
import {decimalStrToNumber} from "../../../../../utils/utils";
import SelectFormElementV2
  from "../../../../RiskProfiling/components/StepContent/components/formElement/SelectFormElementV2";
import InputFormElement
  , {CurrencyNumberFormat} from "../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement";
import CalendarFormElement
  from "../../../../RiskProfiling/components/StepContent/components/formElement/CalendarFormElement";
import {newDesignInputCustomClasses} from "../../../../RiskProfiling/constants";
import {ASSET_MODAL_TYPE_NEW, newDesignInputCustomClassesViewOnly, OTHER_FINANCIAL_CATEGORY} from "../../../constants";
import {dateToMoment, momentToDate} from "../../utils";
import {
  getInvestmentDynamicPath,
  getRouteFullPathByComponent
} from "../../../../InvestmentPlatform/utils";
import {getAuthSelector, getInvestmentPlatformSelector} from "../../../../../utils/redaxSelectors";
import {getBaseUrl} from "../../../../../utils/navigation";
import {DisabledCategoryTooltipWrapper} from "../DisabledCategoryTooltipWrapper";


const OtherDepotForm = (props) => {

  const {
    handleFormChange,
    defaults,
    errors,
    viewOnly,
    auth: {user}
  } = props;

  const [model, setModel] = React.useState({
    name: defaults.name,
    depot_number: defaults.depot_number,
    custodian: defaults.custodian,
    value: decimalStrToNumber(defaults.value),
    value_date: dateToMoment(defaults.value_date),
    purchase_amount: decimalStrToNumber(defaults.purchase_amount),
    purchase_date: dateToMoment(defaults.purchase_date),
    updated: dateToMoment(defaults.updated),
  });

  React.useEffect(() => {
    handleFormChange && handleFormChange({
      ...model,
      value_date: momentToDate(model.value_date),
      purchase_date: momentToDate(model.purchase_date),
    });
  }, [model]);

  const handleModelChange = (field) => (value) => {
    setModel({
      ...model,
      [field]: value
    })
  };

  const inputClasses = viewOnly ? newDesignInputCustomClassesViewOnly : newDesignInputCustomClasses;
  const isCustomer = _.get(user, 'is_customer');

  return (
    <>
      {!viewOnly && (
        <>
          {!isCustomer && (
            <Grid item xs={12}>
              <ExternalDepotHint />
            </Grid>
          )}
          <DisabledCategoryTooltipWrapper isCreate={!defaults.id}>
            <Grid item xs={12}>
              <SelectFormElementV2
                label="Kategorie"
                value={String(ASSET_MODAL_TYPE_NEW.OTHER_DEPOT)}
                options={OTHER_FINANCIAL_CATEGORY.subCategories}
                onChange={handleModelChange('sub_category')}
                disabled
                dataId={'category-input'}
                required
                newDesign
                custom_classes={inputClasses}
              />
            </Grid>
          </DisabledCategoryTooltipWrapper>
        </>
      )}
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label={'Name / Bezeichnung'}
          required={!viewOnly}
          value={model.name}
          error={errors.name}
          dataId={'name-input'}
          onChange={handleModelChange('name')}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label={'Depotnummer'}
          value={model.depot_number}
          error={errors.depot_number}
          dataId={'depot_number-input'}
          onChange={handleModelChange('depot_number')}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label={'Gesellschaft'}
          value={model.custodian}
          error={errors.custodian}
          dataId={'depository-input'}
          onChange={handleModelChange('custodian')}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label="Wert"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.value}
          error={errors.value}
          dataId={'value-input'}
          onChange={handleModelChange('value')}
          required={!viewOnly}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CalendarFormElement
          label="Wertdatum"
          disableFuture
          value={model.value_date}
          error={errors.value_date}
          dataId={'value_date-input'}
          onChange={handleModelChange('value_date')}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label="Einstandswert"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.purchase_amount}
          error={errors.purchase_amount}
          dataId={'purchase_amount-input'}
          onChange={handleModelChange('purchase_amount')}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CalendarFormElement
          label="Einstandsdatum"
          disableFuture
          value={model.purchase_date}
          error={errors.purchase_date}
          dataId={'purchase_date-input'}
          onChange={handleModelChange('purchase_date')}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CalendarFormElement
          label="Stand vom"
          value={model.updated || moment()}
          dataId={'updated-input'}
          disabled
          required={!viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      {!!errors['non_field_errors'] && <NonFieldErrors errors={errors['non_field_errors']}/>}
    </>
  )
};

OtherDepotForm.defaultProps = {
  defaults: {},
  errors: {}
};


const mapOtherDepotFormStateToProps = (state) => ({
  auth: getAuthSelector(state),
});

export default connect(mapOtherDepotFormStateToProps)(OtherDepotForm);

const mapStateToProps = (state) => ({
  investmentPlatform: getInvestmentPlatformSelector(state)
})

const ExternalDepotHint = connect(mapStateToProps)(({investmentPlatform}) => {

  const href = React.useMemo(() => {
    return getBaseUrl(`/${getInvestmentDynamicPath()}${getRouteFullPathByComponent(investmentPlatform.routes, 'MODELPORTFOLIO_LIST')}`)
  }, [investmentPlatform.routes])

  return (
    <>
      Legen Sie ein Fremddepot schnell per Direkteingabe als sonstigen Vermögenswert an.
      Für eine strukturierte Abbildung verwenden Sie unsere <a href={href} target="_blank">Musterdepot Funktion</a>.
      Anschließend wird das Fremddepot unter „Depots“ angezeigt.
    </>
  )
})